export function createDashboardTabsFeature({
  onArTab, onMapTab, onSpherePhotosTab, onPostersTab, onContributorsTab, onSphereTab, onAlphabetsTab,
  startPunchlinesAnim, stopPunchlinesAnim,
}) {
  const dashTabPunchlines    = document.getElementById('dash-tab-punchlines');
  const dashTabPhotos        = document.getElementById('dash-tab-photos');
  const dashTabMapPhotos     = document.getElementById('dash-tab-map-photos');
  const dashTabSpherePhotos  = document.getElementById('dash-tab-sphere-photos');
  const dashTabPosters       = document.getElementById('dash-tab-posters');
  const dashTabContributors  = document.getElementById('dash-tab-contributors');
  const dashTabSphere        = document.getElementById('dash-tab-sphere');
  const dashTabAlphabets     = document.getElementById('dash-tab-alphabets');
  const dashPanelPunchlines  = document.getElementById('dash-panel-punchlines');
  const dashPanelPhotos      = document.getElementById('dash-panel-photos');
  const dashPanelMapPhotos   = document.getElementById('dash-panel-map-photos');
  const dashPanelSpherePhotos = document.getElementById('dash-panel-sphere-photos');
  const dashPanelPosters     = document.getElementById('dash-panel-posters');
  const dashPanelContributors = document.getElementById('dash-panel-contributors');
  const dashPanelSphere      = document.getElementById('dash-panel-sphere');
  const dashPanelAlphabets   = document.getElementById('dash-panel-alphabets');

  let currentSubTab = 'punchlines';

  function setDashTab(active) {
    currentSubTab = active;
    dashTabPunchlines.classList.toggle('dash-tab--active',   active === 'punchlines');
    dashTabPhotos.classList.toggle('dash-tab--active',       active === 'ar');
    dashTabMapPhotos.classList.toggle('dash-tab--active',    active === 'map');
    dashTabSpherePhotos.classList.toggle('dash-tab--active', active === 'sphere-photos');
    dashTabPosters.classList.toggle('dash-tab--active',      active === 'posters');
    dashTabContributors.classList.toggle('dash-tab--active', active === 'contributors');
    dashTabSphere.classList.toggle('dash-tab--active',       active === 'sphere');
    dashTabAlphabets.classList.toggle('dash-tab--active',    active === 'alphabets');
    dashPanelPunchlines.hidden   = active !== 'punchlines';
    dashPanelPhotos.hidden       = active !== 'ar';
    dashPanelMapPhotos.hidden    = active !== 'map';
    dashPanelSpherePhotos.hidden = active !== 'sphere-photos';
    dashPanelPosters.hidden      = active !== 'posters';
    dashPanelContributors.hidden = active !== 'contributors';
    dashPanelSphere.hidden       = active !== 'sphere';
    dashPanelAlphabets.hidden    = active !== 'alphabets';

    // La liste des punchlines (sous-onglet "Punchlines") tourne sur UNE
    // seule boucle rAF partagée, démarrée dès l'entrée dans le dashboard
    // (cf. onTabEffects dans app.js) et jamais arrêtée tant que la liste
    // n'est pas vide -- y compris quand un AUTRE sous-onglet est affiché
    // (elle continue de redessiner tous les mini-canvases, invisibles ou
    // pas). Ça entrait en concurrence avec les animations propres à
    // l'onglet Alphabets (10 canvases en même temps) et les rendait
    // saccadées. Coupée ici dès qu'on quitte "Punchlines", relancée au
    // retour.
    if (active === 'punchlines') {
      startPunchlinesAnim?.();
    } else {
      stopPunchlinesAnim?.();
    }
  }

  dashTabPunchlines.addEventListener('click', () => setDashTab('punchlines'));
  dashTabPhotos.addEventListener('click', () => { setDashTab('ar');  onArTab(); });
  dashTabMapPhotos.addEventListener('click', () => { setDashTab('map'); onMapTab(); });
  dashTabSpherePhotos.addEventListener('click', () => { setDashTab('sphere-photos'); onSpherePhotosTab(); });
  dashTabPosters.addEventListener('click', () => { setDashTab('posters'); onPostersTab(); });
  dashTabContributors.addEventListener('click', () => { setDashTab('contributors'); onContributorsTab(); });
  dashTabSphere.addEventListener('click', () => { setDashTab('sphere'); onSphereTab(); });
  dashTabAlphabets.addEventListener('click', () => { setDashTab('alphabets'); onAlphabetsTab(); });

  return { setDashTab, getDashTab: () => currentSubTab };
}
